import { formatKind } from 'components/practice/NewAppointment/components/Sections/Timeline/lib';

import extractDataFromColDefs from './extractDataFromColDefs';
import { filterColumns } from './helpers';

export const getAgGridData = (gridApi, columns) => {
  const rows = [];

  gridApi.forEachNode((node) => {
    if (node?.data) {
      rows.push(node.data);
    }
  });

  if (!columns?.length) {
    columns = getAgGridColumns(gridApi);
  }

  //formatted data
  const data = extractDataFromColDefs(rows, columns);

  return { rows, data, columns };
};

export const getAgGridColumns = (gridApi) => {
  return filterColumns(gridApi.getColumnDefs()).map((col) => ({
    ...col,
    headerName: col.headerName || formatKind(col.field)
  }));
};
